/**
 * Builds the inline `animation` values for the empty-state entrances. Returns
 * `undefined` under reduced motion so elements render in their final position
 * with no entrance at all.
 */
export function makeEntrance(reduceMotion: boolean) {
  const anim = (name: string, delay: number, duration = 0.5) =>
    reduceMotion ? undefined : `${name} ${duration}s ease-out ${delay}s both`;

  return {
    /** The glass card materialises: blur, border, fill and shadow fade up as it rises. */
    glassIn: (delay: number) => anim("glass-in", delay),
    /** A plain opacity fade, used for the card's inset highlight overlay. */
    fadeIn: (delay: number) => anim("fade-in", delay),
    /** The base 14px rise used by text, card bodies and the actions. */
    fadeInUp: (delay: number) => anim("fade-in-up", delay),
  };
}
